import React, { useRef, useState } from "react";
import { FolderCheck, Upload , Trash2 } from "lucide-react";
import "./index.scss";

function formatFileSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
}

const CsvUploadPanel = ({ onFileUpload, uploadedFile,onRemoveFile }) => {
    const [isDragging, setIsDragging] = useState(false);
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) onFileUpload(file);
  };

  
   const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

   const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    if (file) {
      if (!file.name.toLowerCase().endsWith(".csv")) {
        alert("Only .csv files are supported.");
        return;
      }
      onFileUpload(file);
    }
  };

  const fileName =
  uploadedFile?.name ??
  sessionStorage.getItem("selectedReportName") ??
  "No file selected";
  return (
    <div className="csv-upload-panel">
      <div className="cup-header">
        <h4>Document Upload</h4>
        <p>Upload CSV file to analyze</p>
      </div>

      <div className="cup-body">
        <div
          className={`upload-box ${isDragging ? "dragging" : ""}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleClick}
        >
          <div className="upload-icon">
            <Upload size={36} />
          </div>
          <div className="upload-title">
            {uploadedFile ? "Replace File" : "Drop CSV here"}
          </div>
          <div className="upload-desc">
            or click to browse
            <br />
            <span className="upload-size-hint">Max 4MB, .csv only</span>
          </div>
          <div className="choose-btn">
            <FolderCheck size={14} />
            {uploadedFile ? "Choose New File" : "Choose File"}
          </div>
        </div>

        {uploadedFile && (
          <div className="current-file">
            <div className="current-file-top">
              <div>
                <div className="label">Current File</div>
                <div className="file-name">{fileName}</div>
                {uploadedFile.size && (
                  <div className="file-size">
                    {formatFileSize(uploadedFile.size)}
                  </div>
                )}
              </div>

              <button
                className="remove-file-btn"
                onClick={onRemoveFile}
                title="Remove file"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        )}

        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleFileChange}
          accept=".csv"
          className="hidden-file-input"
        />
      </div>
    </div>
  );
};

export default CsvUploadPanel;
